var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .25a9.75 9.75 0 110 19.501A9.75 9.75 0 0110 .25zm0 1.5a8.25 8.25 0 100 16.501A8.25 8.25 0 0010 1.75zm2.47 6.72a.75.75 0 011.06 1.06l-3 3a.75.75 0 01-1.06 0l-3-3-.052-.057a.75.75 0 011.056-1.055l.056.051L10 10.94l2.47-2.47z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRounded);
export default __webpack_public_path__ + "static/media/check-rounded.90e6abf2a35751bd4efec615a8209e87.svg";
export { ForwardRef as ReactComponent };